var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcP3Smpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 105,
    viewBox: "0 0 118 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1097_750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 105
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 105,
    rx: 16,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1097_750)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1097_750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 0H0V104.997H118V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1097_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8873 -11H-27V113H64.2774C66.3488 113 68.4201 112.794 70.4224 112.331C78.1554 110.582 93.6215 105.488 105.014 94.3743C111.366 88.2 114.611 81.6141 116.061 75.4913C118.685 64.4805 115.716 53.1095 108.328 43.3851C97.419 29.1328 86.5789 14.8805 75.6698 0.628217C75.2555 0.0622415 74.7722 -0.503734 74.2199 -1.06971C72.7009 -2.66473 70.4914 -4.56846 67.5225 -6.36929C64.4845 -8.27303 61.4466 -9.50788 58.9609 -10.3826C57.7181 -10.7942 56.2682 -11 54.8873 -11Z",
    fill: "#B5CCF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1097_750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 0H0V104.997H118V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1097_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5908 -3H-18V105H61.8992C63.6993 105 65.4995 104.795 67.2304 104.435C74.0156 102.894 87.5167 98.4779 97.4868 88.8231C103.026 83.4308 105.864 77.7304 107.18 72.3894C109.465 62.786 106.903 52.9258 100.395 44.4522C90.9093 32.0243 81.3547 19.6476 71.8692 7.21969C71.4538 6.70613 71.0384 6.19258 70.623 5.73039C69.3075 4.3438 67.3689 2.70043 64.8071 1.10842C62.1069 -0.53495 59.4759 -1.66476 57.3295 -2.38374C56.014 -2.84593 54.837 -3 53.5908 -3Z",
    fill: "url(#paint0_linear_1097_750)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1097_750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 105
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 0H0V105H118V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1097_750)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8926 34.3796C43.7375 33.449 44.1511 32.4667 44.9266 31.898C45.547 31.4844 46.1157 31.381 46.4776 31.3293C46.581 31.3293 46.6327 31.3293 46.736 31.3293H52.2678C52.6297 31.3293 53.0433 31.381 53.3535 31.5878C53.5086 31.6912 53.7154 31.7946 53.8705 31.898C53.9222 31.898 53.9222 31.9497 53.9739 31.9497C54.7493 32.5184 55.1112 33.449 54.9561 34.3279C54.8527 35.0517 54.5425 35.9822 53.8705 36.9128C52.578 38.6189 50.7168 39.0324 50.0965 39.1358C49.9931 39.1358 49.8897 39.1358 49.7863 39.1358C49.1142 39.1358 46.5292 39.0324 44.8749 36.9128C44.3062 36.0339 43.996 35.1033 43.8926 34.3796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0328 48.3043C73.8777 47.3737 74.2913 46.3914 75.0667 45.8227C75.6871 45.4091 76.2558 45.3057 76.6177 45.254C76.7211 45.254 76.7728 45.254 76.8762 45.254H82.4079C82.7698 45.254 83.1834 45.3057 83.4936 45.5125C83.6487 45.6159 83.8555 45.7193 84.0106 45.8227C84.0623 45.8227 84.0623 45.8744 84.114 45.8744C84.8895 46.4431 85.2514 47.3737 85.0963 48.2526C84.9929 48.9763 84.6827 49.9069 84.0106 50.8375C82.7181 52.5435 80.857 52.9571 80.2366 53.0605C80.1332 53.0605 80.0298 53.0605 79.9264 53.0605C79.2543 53.0605 76.6694 52.9571 75.015 50.8375C74.4463 49.9586 74.1362 49.028 74.0328 48.3043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0323 8.05022C45.8772 7.11965 46.2908 6.13737 47.0662 5.56868C47.6866 5.1551 48.2553 5.0517 48.6172 5C48.7206 5 48.7723 5 48.8757 5H54.4075C54.7693 5 55.1829 5.0517 55.4931 5.25849C55.6482 5.36189 55.855 5.46529 56.0101 5.56868C56.0618 5.56868 56.0618 5.62039 56.1135 5.62039C56.889 6.18907 57.2509 7.11965 57.0958 7.99852C56.9924 8.72231 56.6822 9.65288 56.0101 10.5835C54.7176 12.2895 52.8565 12.7031 52.2361 12.8065C52.1327 12.8065 52.0293 12.8065 51.9259 12.8065C51.2538 12.8065 48.6689 12.7031 47.0145 10.5835C46.4459 9.70458 46.1357 8.774 46.0323 8.05022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01371 22.8508C7.85862 21.9202 8.27221 20.9379 9.04769 20.3692C9.66807 19.9556 10.2368 19.8522 10.5986 19.8005C10.702 19.8005 10.7537 19.8005 10.8571 19.8005H16.3889C16.7508 19.8005 17.1644 19.8522 17.4746 20.059C17.6297 20.1624 17.8365 20.2658 17.9916 20.3692C18.0433 20.3692 18.0433 20.4209 18.095 20.4209C18.8704 20.9896 19.2323 21.9202 19.0772 22.7991C18.9738 23.5228 18.6636 24.4534 17.9916 25.384C16.6991 27.09 14.8379 27.5036 14.2176 27.607C14.1142 27.607 14.0108 27.607 13.9074 27.607C13.2353 27.607 10.6503 27.5036 8.99599 25.384C8.37561 24.5568 8.11711 23.6262 8.01371 22.8508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30755 45.7016C7.23812 45.5465 8.2204 45.9601 8.78908 46.7356C9.20267 47.3559 9.30607 47.9246 9.35777 48.2865C9.35777 48.3899 9.35777 48.4416 9.35777 48.545V54.0768C9.35777 54.4387 9.30607 54.8522 9.09927 55.1624C8.99588 55.3175 8.89248 55.5243 8.78908 55.6794C8.78908 55.7311 8.73739 55.7311 8.73739 55.7828C8.1687 56.5583 7.23812 56.9202 6.35924 56.7651C5.63546 56.6617 4.70489 56.3515 3.77431 55.6794C2.06826 54.387 1.65467 52.5258 1.55127 51.9054C1.55127 51.802 1.55127 51.6986 1.55127 51.5952C1.55127 50.9231 1.65467 48.3382 3.77431 46.6839C4.60149 46.0635 5.58376 45.805 6.30755 45.7016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9235 84.5658C67.699 85.1345 68.1126 86.1167 67.9058 87.0473C67.7507 87.7711 67.3888 88.2364 67.182 88.5466C67.1303 88.5983 67.0786 88.65 67.0269 88.7017L63.0978 92.6308C62.8393 92.8893 62.5291 93.0961 62.1672 93.2512C62.0121 93.3029 61.8053 93.3546 61.5468 93.4063C61.4951 93.4063 61.4951 93.4063 61.4434 93.4063C60.5129 93.5614 59.5823 93.1478 59.0653 92.3723C58.6 91.7519 58.1347 90.9247 57.9796 89.7873C57.6694 87.6677 58.7034 86.065 59.0653 85.5481C59.117 85.4447 59.1687 85.393 59.2721 85.3413C59.7374 84.876 61.6502 83.1182 64.3386 83.4801C65.4242 83.6352 66.3031 84.1005 66.9235 84.5658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.863 90.0074C34.6384 90.5761 35.052 91.5584 34.8452 92.489C34.6901 93.2128 34.3282 93.678 34.1215 93.9882C34.0698 94.0399 34.0181 94.0916 33.9664 94.1433L30.0373 98.0724C29.7788 98.3309 29.4686 98.5377 29.1067 98.6928C28.9516 98.7445 28.7448 98.7962 28.4863 98.8479C28.4346 98.8479 28.4346 98.8479 28.3829 98.8479C27.4523 99.003 26.5217 98.5894 26.0048 97.8139C25.5395 97.1935 25.0742 96.3664 24.9191 95.229C24.6089 93.1094 25.6429 91.5067 26.0048 90.9897C26.0565 90.8863 26.1082 90.8346 26.2116 90.7829C26.6768 90.3176 28.5897 88.5599 31.278 88.9218C32.3637 89.0769 33.2426 89.5422 33.863 90.0074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1244 17.0605C29.8375 17.0605 31.2263 15.6718 31.2263 13.9586C31.2263 12.2455 29.8375 10.8567 28.1244 10.8567C26.4112 10.8567 25.0225 12.2455 25.0225 13.9586C25.0225 15.6718 26.4112 17.0605 28.1244 17.0605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3373 83.8036C18.0504 83.8036 19.4392 82.4148 19.4392 80.7017C19.4392 78.9885 18.0504 77.5997 16.3373 77.5997C14.6241 77.5997 13.2354 78.9885 13.2354 80.7017C13.2354 82.4148 14.6241 83.8036 16.3373 83.8036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5721 65.2954C66.2853 65.2954 67.6741 63.9066 67.6741 62.1935C67.6741 60.4803 66.2853 59.0916 64.5721 59.0916C62.859 59.0916 61.4702 60.4803 61.4702 62.1935C61.4702 63.9066 62.859 65.2954 64.5721 65.2954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7123 79.2201C96.4254 79.2201 97.8142 77.8313 97.8142 76.1182C97.8142 74.405 96.4254 73.0162 94.7123 73.0162C92.9991 73.0162 91.6104 74.405 91.6104 76.1182C91.6104 77.8313 92.9991 79.2201 94.7123 79.2201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4245 26.0044C50.5095 26.0044 51.3891 25.1249 51.3891 24.0399C51.3891 22.9549 50.5095 22.0753 49.4245 22.0753C48.3395 22.0753 47.46 22.9549 47.46 24.0399C47.46 25.1249 48.3395 26.0044 49.4245 26.0044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5646 39.9291C80.6496 39.9291 81.5292 39.0495 81.5292 37.9646C81.5292 36.8796 80.6496 36 79.5646 36C78.4797 36 77.6001 36.8796 77.6001 37.9646C77.6001 39.0495 78.4797 39.9291 79.5646 39.9291Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1097_750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 105
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 0H0V104.997H118V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1097_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0223 49.6003C38.22 47.808 37.1043 45.326 37.1043 42.5834C37.1043 39.8408 38.22 37.3588 40.0223 35.5665C38.9847 35.057 37.8175 34.7709 36.5835 34.7709C32.2688 34.7709 28.771 38.2686 28.771 42.5834C28.771 46.8981 32.2688 50.3959 36.5835 50.3959C37.8175 50.3959 38.9847 50.1098 40.0223 49.6003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1877 42.5834C39.1877 38.2686 42.6854 34.7709 47.0002 34.7709C51.3149 34.7709 54.8127 38.2686 54.8127 42.5834C54.8127 46.8981 51.3149 50.3959 47.0002 50.3959C42.6854 50.3959 39.1877 46.8981 39.1877 42.5834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.978 35.5665C55.7803 37.3588 56.896 39.8408 56.896 42.5834C56.896 45.326 55.7803 47.808 53.978 49.6003C55.0157 50.1098 56.1828 50.3959 57.4168 50.3959C61.7316 50.3959 65.2293 46.8981 65.2293 42.5834C65.2293 38.2686 61.7316 34.7709 57.4168 34.7709C56.1828 34.7709 55.0157 35.057 53.978 35.5665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9377 61.3334C32.9377 57.0186 36.4354 53.5209 40.7502 53.5209H53.2502C57.5649 53.5209 61.0627 57.0186 61.0627 61.3334C61.0627 65.6481 57.5649 69.1459 53.2502 69.1459H40.7502C36.4354 69.1459 32.9377 65.6481 32.9377 61.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.521 59.25C22.521 54.9353 26.0188 51.4375 30.3335 51.4375H40.7502C35.2848 51.4375 30.8543 55.8681 30.8543 61.3334C30.8543 63.4685 31.5305 65.4457 32.6805 67.0625H30.3335C26.0188 67.0625 22.521 63.5648 22.521 59.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.146 61.3334C63.146 63.4685 62.4698 65.4457 61.3198 67.0625H63.6668C67.9816 67.0625 71.4793 63.5648 71.4793 59.25C71.4793 54.9353 67.9816 51.4375 63.6668 51.4375H53.2502C58.7155 51.4375 63.146 55.8681 63.146 61.3334Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1097_750",
    x1: -38.5412,
    y1: 80.2902,
    x2: 62.7271,
    y2: -3.75103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A1E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcP3Smpt);
export default __webpack_public_path__ + "static/media/ic-p3smpt.b548f7cbdef224b2f211395e43916e38.svg";
export { ForwardRef as ReactComponent };